var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApSprinklerSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.61 -4.687)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.61 4.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.778,24.631H46.662c-.584,0-1.058.343-1.058.767s.473.767,1.058.767h2.116c1.751,0,3.174-1.032,3.174-2.3v-.909A2.489,2.489,0,0,0,54.067,20.8V13.125a2.485,2.485,0,0,0-2.116-2.159V9.289h1.058c1.751,0,3.174-1.032,3.174-2.3V6.221h1.058c.584,0,1.058-.343,1.058-.767s-.473-.767-1.058-.767H27.62c-.584,0-1.058.343-1.058.767s.473.767,1.058.767h1.058v.767c0,1.269,1.423,2.3,3.174,2.3H32.91v1.676a2.489,2.489,0,0,0-2.116,2.159V20.8a2.485,2.485,0,0,0,2.116,2.159v.909c0,1.269,1.423,2.3,3.174,2.3H38.2c.584,0,1.058-.343,1.058-.767s-.473-.767-1.058-.767H36.083c-.582,0-1.058-.343-1.058-.767V23.1h14.81v.767C49.836,24.288,49.36,24.631,48.778,24.631ZM30.794,6.988V6.221H54.067v.767c0,.424-.476.767-1.058.767H31.852c-.582,0-1.058-.343-1.058-.767Zm19.042,2.3v1.534H35.026V9.289Zm-3.174,6.137H38.2c-.582,0-1.058-.343-1.058-.767v-2.3H47.72v2.3C47.72,15.083,47.244,15.426,46.662,15.426ZM33.968,21.562c-.582,0-1.058-.343-1.058-.767V13.125c0-.424.476-.767,1.058-.767h1.058v2.3a2.485,2.485,0,0,0,2.116,2.159v4.744Zm5.289,0v-4.6H45.6v4.6Zm8.463,0V16.818a2.489,2.489,0,0,0,2.116-2.159v-2.3h1.058c.582,0,1.058.343,1.058.767V20.8c0,.424-.476.767-1.058.767Z",
    transform: "translate(-26.563 -4.687)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3,53.792a.768.768,0,0,0,.7-.445l.322-.7a.767.767,0,1,0-1.392-.644l-.322.7a.767.767,0,0,0,.7,1.089Z",
    transform: "translate(-30.985 -28.549)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.564,61.238a.766.766,0,0,0,.7-.445l.612-1.325a.767.767,0,1,0-1.392-.642l-.612,1.325a.769.769,0,0,0,.7,1.089Z",
    transform: "translate(-29.713 -32.019)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.826,69.336a.766.766,0,0,0,.7-.445l.612-1.325a.767.767,0,1,0-1.392-.642l-.612,1.325a.769.769,0,0,0,.7,1.089Z",
    transform: "translate(-28.479 -36.142)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.08,53.347a.768.768,0,0,0,.7.445.777.777,0,0,0,.322-.071.766.766,0,0,0,.374-1.018l-.322-.7a.767.767,0,1,0-1.392.644Z",
    transform: "translate(-35.355 -28.549)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.254,68.89a.767.767,0,0,0,1.392-.644l-.612-1.325a.767.767,0,1,0-1.392.642l.612,1.325Z",
    transform: "translate(-37.562 -36.141)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.516,60.792a.767.767,0,0,0,1.392-.644L59.3,58.822a.767.767,0,1,0-1.392.642l.612,1.325Z",
    transform: "translate(-36.328 -32.018)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.971,52.33a.767.767,0,0,0-1.534,0V53.1a.767.767,0,1,0,1.534,0Z",
    transform: "translate(-33.337 -28.55)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.971,70.939a.767.767,0,1,0-1.534,0v1.674a.767.767,0,1,0,1.534,0Z",
    transform: "translate(-33.337 -38.023)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.971,60.709a.767.767,0,1,0-1.534,0v1.674a.767.767,0,0,0,1.534,0Z",
    transform: "translate(-33.337 -32.815)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.971,46.08a.767.767,0,0,1-1.534,0,.767.767,0,0,1,1.534,0",
    transform: "translate(-33.337 -25.369)",
    stroke: "#f0f8ff",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApSprinklerSystemIcon);
export default __webpack_public_path__ + "static/media/ap-sprinkler-system-icon.ef8c17cee57d98a6a950b53c0d9dd13e.svg";
export { ForwardRef as ReactComponent };